import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { generateRandomUUID } from '@/utils';
import { sendLogin } from '../api';
import { loginMutationKeys } from '../data';

// Type guard to check for TFA response
const isTFAResponse = (
  data: Awaited<ReturnType<typeof sendLogin>>['data'],
): data is { preAuthToken: string; expiresAt: number } => {
  return 'preAuthToken' in data && 'expiresAt' in data;
};

export const useSendLoginMutation = () => {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationKey: loginMutationKeys.sendLogin,
    mutationFn: sendLogin,

    onMutate: (data) => ({ ...data, errorId: generateRandomUUID() }),

    onSuccess: (response) => {
      if (isTFAResponse(response.data)) {
        const expiryDate = new Date(response.data.expiresAt);

        Cookies.set('pre_auth_token', response.data.preAuthToken, {
          domain: ENV.WHAT_ABILITY_DOMAIN,
          expires: expiryDate,
        });

        toast.success('Authenticated');
        navigate('/otp');
      } else {
        // 2FA not enabled — store access/refresh tokens
        Cookies.set('access_token', response.data.tokenResponse.accessToken, {
          domain: ENV.WHAT_ABILITY_DOMAIN,
          expires: 1, // 1 day
        });

        Cookies.set('refresh_token', response.data.tokenResponse.refreshToken, {
          domain: ENV.WHAT_ABILITY_DOMAIN,
          expires: 30, // 30 days
        });

        toast.success('Authenticated');
        navigate('/dashboard'); // or wherever the default route is
      }
    },

    onError: () => {
      toast.error('Invalid credentials');
    },
  });

  return mutation;
};